import React from 'react';
import { addPopupAction } from 'js/components/common/PopupManager';
import { BonusWithGamesPopup } from '../BonusWithGamesPopup';
import { useFormatter } from 'js/hooks/useFormatter';
import { I18n } from 'js/components/common/I18n';

export const showGoldenChipsPopupAction = (data) => {
    const { goldenChips } = data.rawBonusDetails.bonus;
    const { goldenChipsCount, goldenChipValue: { amount, currencyCode } } = goldenChips;
    const tKey = 'playtech.mobile.system.goldenchips-popup.description';

    const useDescription = () => {
        const formatter = useFormatter();
        const goldenChipsValue = formatter.formatCurrency(amount, { currencyCode });

        return <I18n tKey={tKey} replacers={[goldenChipsCount, goldenChipsValue]} />;
    };

    return addPopupAction({
        ...data,
        useDescription,
        component: BonusWithGamesPopup
    });
};
